class RegulatoryFormService {
  get_data(page, data) {
    return axios.post('general/regulatory-violation-form?page=' + page, data)
  }
  get(id) {
    return axios.get('general/regulatory-violation-form/' + id)
  }
  add(data) {
    return axios.post('general/regulatory-violation-form/store', data)
  }
  edit(id, data) {
    return axios.post('general/regulatory-violation-form/update/' + id, data)
  }
  delete(id) {
    return axios.delete('general/regulatory-violation-form/delete/' + id)
  }

}
export default new RegulatoryFormService();